import { largoDelMotivo, motivoEsValido } from "./cambio-de-estado";

/**
 * Las reglas de interfaz de eliminar una OT y de su detalle una vez eliminada.
 * Ver ADR 0100 (B3, B4, B7, B8).
 *
 * **El worker revalida todo** (invariante 5): esto decide qué se ofrece, no qué
 * se permite. Si difieren, el diálogo muestra el error del worker.
 */

/** Solo desde `BORRADOR`, y solo con `produccion.delete`. */
export function puedeEliminar(
  estado: string,
  can: (recurso: "produccion", accion: string) => boolean,
): boolean {
  return estado === "BORRADOR" && can("produccion", "delete");
}

/** El motivo es opcional (B4): en blanco vale; si viene, de 10 a 500. */
export function motivoOpcionalValido(texto: string): boolean {
  return largoDelMotivo(texto) === 0 || motivoEsValido(texto);
}

/** Toda escritura sobre una `ELIMINADA` es 409 (B8): el detalle no la ofrece. */
export function esSoloLectura(estado: string): boolean {
  return estado === "ELIMINADA";
}

/** Quién, cuándo y por qué, de la transición a `ELIMINADA` del historial (B3). */
export function eliminacionDe(
  historial: readonly {
    estadoNuevo: string;
    usuario: string | null;
    ocurrioEn: string;
    motivo: string | null;
  }[],
): { cuando: string; quien: string | null; motivo: string | null } | null {
  const fila = historial.find((h) => h.estadoNuevo === "ELIMINADA");
  if (!fila) return null;
  return { cuando: fila.ocurrioEn, quien: fila.usuario, motivo: fila.motivo };
}
